module.exports = __webpack_public_path__ + "img/modelo-acai.91aa0a06.png";